/**
 * Promise.allSettled, for the browsers of the production browserslist that have none: waits for every promise and never rejects.
 * @param {Array<Promise|*>} promises
 * @returns {Promise<Array<{status: 'fulfilled', value: *}|{status: 'rejected', reason: *}>>} one answer for each promise, in the promises' order
 */
export const settleAll = promises => Promise.all(promises.map(promise => Promise.resolve(promise).then(
    value => ({status: 'fulfilled', value}),
    reason => ({status: 'rejected', reason}),
)));
